import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useParams } from 'react-router-dom';
import remarkGfm from 'remark-gfm';
import GenericError from 'src/component/GenericError';
import { useGetCourseLesson } from 'src/hook/CourseLessonHook';
import useGetMarkdownFile from 'src/hook/MarkdownHook';
import CourseLesson from 'src/model/CourseLesson';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';

import 'katex/dist/katex.min.css'; // `rehype-katex` does not import the CSS for you

export default function CourseLessonPage() {
  const { courseId, courseChapterId, courseLessonId } = useParams();
  const [errorState, setError] = useState(false);
  const courseLessonState: CourseLesson = useGetCourseLesson(setError, courseLessonId);
  const markdownPath = `course/${courseId}/${courseChapterId}/${courseLessonId}`;
  const markdownTextState = useGetMarkdownFile(setError, markdownPath);

  if (errorState) {
    return <GenericError errorMessage="" />;
  }
  return (
    <Box
      sx={{
        mt: 5,
      }}
    >
      <Container>
        <Grid container>
          <Grid item xs={12}>
            <Typography
              component="h2"
              variant="h2"
              align="center"
              color="text.primary"
              gutterBottom
            >
              {courseLessonState.title}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ReactMarkdown remarkPlugins={[remarkGfm, remarkMath]} rehypePlugins={[rehypeKatex]}>
              {markdownTextState}
            </ReactMarkdown>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
